import paymentMethodName from './paymentMethodName';

const paymentMethodLocaleName = (type, laymanMode = false) =>
  I18n.t(paymentMethodName(type, laymanMode), {
    scope: 'ibe.payment.payment_type',
  });

export default paymentMethodLocaleName;
